module.exports = __webpack_public_path__ + "static/9-c4564d8b551df8b30ad096ef82a261de.jpg";